
const gwTree = {
  state: {
    gwTreeState: false,
    gwTreeBranchId: '',
    gwTreeBranchName: '',

    gwTreePostInfo: '',  // 全的岗位信息
    gwTreePostId: '',
    gwTreePostName: '',

    gwStr: '',

    // jiangangshenqing   减岗申请
    // gangweitingyong 岗位停用
    // ruzhishenqing  入职申请
    // gangweiqiyong 岗位启用
    gwTreeSqType: '',  // 岗位状态

  },

  mutations: {
    SET_GWTREESTATE: (state, gwTreeState) => {
      state.gwTreeState = gwTreeState
    },
    SET_GWTREEBRANCHID: (state, gwTreeBranchId) => {
      state.gwTreeBranchId = gwTreeBranchId
    },
    SET_GWTREEBRANCHNAME: (state, gwTreeBranchName) => {
      state.gwTreeBranchName = gwTreeBranchName
    },
    SET_GWTREEPOSTID: (state, gwTreePostId) => {
      state.gwTreePostId = gwTreePostId
    },
    SET_GWTREEPOSTNAME: (state, gwTreePostName) => {
      state.gwTreePostName = gwTreePostName
    },
    SET_GWTREEPOSTINFO: (state, gwTreePostInfo) => {
      state.gwTreePostInfo = gwTreePostInfo
    },
    SET_GWSTR: (state, gwStr) => {
      state.gwStr = gwStr
    },

    SET_GWTREESQTYPE: (state, val) => {
      state.gwTreeSqType = val
    }
  },

  actions: {
    
  }
}

export default gwTree
